<app-header></app-header>
<div class="h-full bg-gray">
    <div class="contract-container">

        <div *ngIf="isLoading" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div *ngIf="loadError" style="color:red; text-align:center; padding:24px;">
            {{ loadError }}
        </div>

        <div class="contract-card" *ngIf="!isLoading && !loadError">

            <!-- Title -->
            <h2 class="contract-title">Merchant Chargeback Management Services Contract</h2>

            <!-- Client / Provider Info -->
            <div class="parties-section">
                <div class="party-block">
                    <span class="party-label">The client</span>
                    <p class="party-detail">
                        {{ companyName || 'N/A' }}
                        <ng-container *ngFor="let line of clientAddressLines">
                            <br>{{ line }}
                        </ng-container>
                    </p>
                </div>
                <div class="party-block party-right">
                    <span class="party-label">The service provider</span>
                    <p class="party-detail">Fraud Deflect<br>425 Town Plaza Ave<br>Ponte Vedra FL, 32081</p>
                </div>
            </div>

            <!-- Divider -->
            <hr class="section-divider" />

            <!-- Service & Fees -->
            <div class="section">
                <p>
                    <span class="section-label">Service &amp; Fees:</span>
                    <span class="section-text">
                        The Client agrees to pay the following to the Service Provider for the services provided under
                        this Contract.
                        This payment shall be made weekly, and the first installment shall be due the Monday after the
                        invoice date.
                        The services to be provided by the service provider to the client are as follows:
                    </span>
                </p>

                <div class="fees-table">
                    <div class="fee-row" *ngFor="let svc of services">
                        <span class="fee-name">{{ svc.service }}</span>
                        <span class="fee-amounts">
                            <!-- Same fee or no loss fee: single value, no legend -->
                            <ng-container
                                *ngIf="svc.feeLoss == null || svc.feeWin === svc.feeLoss; else splitFees">
                                <span class="fee-amount">
                                    ${{ svc.feeWin | number:'1.2-2' }}
                                </span>
                            </ng-container>
                            <!-- Different fees: show with Win/Loss labels -->
                            <ng-template #splitFees>
                                <span class="fee-amount">
                                    Win: ${{ svc.feeWin | number:'1.2-2' }}
                                </span>
                                <span class="fee-amount">
                                    Loss: ${{ svc.feeLoss | number:'1.2-2' }}
                                </span>
                            </ng-template>
                        </span>
                    </div>
                    <div class="fee-row" *ngIf="!services?.length">
                        <span class="fee-name">No services configured</span>
                        <span class="fee-amounts">-</span>
                    </div>
                </div>
            </div>

            <!-- Divider -->
            <hr class="section-divider" />

            <!-- Terms & Conditions -->
            <div class="section">
                <p>
                    <span class="section-label">Terms &amp; Conditions and Privacy Policy:</span><br>
                    <a class="section-link" href="https://frauddeflect.com/privacy-policy-2025" target="_blank"
                        rel="noopener noreferrer">
                        https://frauddeflect.com/privacy-policy-2025
                    </a>
                </p>
            </div>

            <!-- Payment Information -->
            <div class="section">
                <p>
                    <span class="section-label">Payment information:</span><br>
                    <span class="section-text">
                        Client agrees to provide the necessary payment information, either via ACH (bank transfer) or
                        credit card,
                        prior to the start of the onboarding process, in order to configure automatic billing through
                        the Bill.com platform.
                        Onboarding and service activation are conditional upon receipt of this information and
                        successful setup of auto-pay.
                        Client expressly authorizes automatic charges as outlined in this agreement.
                        A convenience fee of 3% will apply to any payments made by credit card.
                    </span>
                </p>
            </div>

            <!-- Contract Term -->
            <div class="section">
                <p>
                    <span class="section-label">Contract Term:</span><br>
                    <span class="section-text">
                        Fraud Deflect confirms that the standard one-year contract requirement is hereby waived.
                        Services will be provided on a month-to-month basis, and the Client may discontinue services at
                        any time without penalty.
                        Upon cancellation, Fraud Deflect will hold an amount equivalent to one-half (½) month of service
                        fees to cover any trailing
                        alerts received after cancellation and before the Client is fully enrolled with a new service
                        provider.
                        Any remaining balance after trailing alerts are reconciled will be refunded to the Client.
                    </span>
                </p>
            </div>

            <!-- Acknowledgment Checkbox -->
            <div class="acknowledge-row">
                <mat-checkbox [(ngModel)]="acknowledged" color="primary" class="acknowledge-checkbox">
                    <span class="acknowledge-text">
                        By proceeding, I confirm that I accept the terms of this contract,
                        as well as the terms &amp; conditions and privacy policy.
                    </span>
                </mat-checkbox>
            </div>

            <!-- Save Button -->
            <div class="save-container">
                <button mat-raised-button class="save-button" [disabled]="!acknowledged || isSaving" (click)="save()">
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
            </div>

        </div>
    </div>
</div>
